import { render, staticRenderFns } from "./nested.vue?vue&type=template&id=19dfd1d8&scoped=true"
import script from "./nested.vue?vue&type=script&lang=js"
export * from "./nested.vue?vue&type=script&lang=js"
import style0 from "./nested.vue?vue&type=style&index=0&id=19dfd1d8&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dfd1d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19dfd1d8')) {
      api.createRecord('19dfd1d8', component.options)
    } else {
      api.reload('19dfd1d8', component.options)
    }
    module.hot.accept("./nested.vue?vue&type=template&id=19dfd1d8&scoped=true", function () {
      api.rerender('19dfd1d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/layout-preview/nested.vue"
export default component.exports